import React from 'react';

interface MarkdownParserProps {
  markdownText: string;
}

const MarkdownParser: React.FC<MarkdownParserProps> = ({ markdownText }) => {
  const parseMarkdown = (markdown: string): string => {
    markdown = markdown.replace(
      /\*\*Attendees:\*\*\n/gim,
      `<div class="font-bold mb-2">Attendees:</div><div class="flex gap-2 mb-4">`,
    );
    markdown = markdown.replace(
      /- ([^\n]*)\n/gim,
      '<span class="inline-flex items-center px-3 py-1 text-sm font-bold text-gray-700 rounded-full">$1</span>',
    );
    markdown = markdown.replace(/<\/span>(?!\s*<span)/gim, '</span></div>');
    markdown = markdown.replace(
      /^\d*\.\s*(#+) (.*)$/gim,
      (match, hashes: string, text: string) => {
        switch (hashes.length) {
          case 1:
            return `<h1 class="text-2xl font-bold mb-4">${text}</h1>`;
          case 2:
            return `<h2 class="text-xl font-bold mb-3">${text}</h2>`;
          case 3:
            return `<h3 class="text-lg font-bold mb-2">${text}</h3>`;
          default:
            return `<h4>${text}</h4>`;
        }
      },
    );

    markdown = markdown.replace(
      /\*\*(.*?)\*\*/gim,
      '<strong class="font-semibold">$1</strong>',
    );

    markdown = markdown.replace(/\*(.*?)\*/gim, '<em class="italic">$1</em>');

    markdown = markdown.replace(
      /^\s*\n\* (.*)/gim,
      '<ul class="list-disc list-inside mb-4"><li>$1</li></ul>',
    );
    markdown = markdown.replace(/^\* (.*)/gim, '<li class="mb-2">$1</li>');

    markdown = markdown.replace(/\n{2,}/gim, '<br /><br />');

    return markdown.trim();
  };

  return (
    <div dangerouslySetInnerHTML={{ __html: parseMarkdown(markdownText) }} />
  );
};

export default MarkdownParser;
